import React from 'react'
import {useStyles} from "./UserCard.css";
import {Card, CardContent, CardMedia, Divider, Tooltip} from "@mui/material";
import AssociationLogo from "../../../../../commons/utils/logo/AssociationLogo";
import UserProfilePicture from "../../overview/UserProfilePicture";
import {useIntl} from "react-intl";

const UserCard = ({user, headerSize, textSize}) => {
    const classes = useStyles({
        headerSize: headerSize,
        textSize: textSize,
        mdComplete: user.firstName && user.secondName
    })

    // Internationalization for simple strings
    const intl = useIntl();

    return (
        <Tooltip title={user.firstName && user.secondName
            ? 'User master data is complete'
            : 'User master data is incomplete'}>
            <Card className={classes.userCard}>
                <CardMedia>
                    <UserProfilePicture user={user} width={60} height={60}/>
                </CardMedia>
                <CardContent className={classes.userCardContent}>
                    <div className={classes.row}>
                        <div className={classes.userHeader}>
                            {user.firstName && user.secondName
                                ? user.firstName + ' ' + user.secondName
                                : user.displayName}
                        </div>
                        <div className={classes.tightRow}>
                            {user.roleScopes?.map((scope) => <AssociationLogo key={scope}
                                                                              association={scope}
                                                                              height={30}
                                                                              width={30}/>)}
                        </div>
                    </div>
                    <Divider orientation={"horizontal"} style={{width: "100%"}}/>
                    <div className={classes.row}>
                        <div className={classes.userContent}>
                            {user.email}
                        </div>
                        <div style={{fontWeight: "bold"}}>
                            {intl.formatMessage({
                                id: `app.ids.role.${user.role}`,
                                defaultMessage: user.role
                            })}
                        </div>
                    </div>
                </CardContent>
            </Card>
        </Tooltip>
    )
}

export default UserCard
